export const events = {
  LOGIN: "login",
  LOGOUT: "logout",
  REGISTRATION: "registration",
  FORGOT_PASSWORD: "forgot-password",
  GET_PROFILE: "get-profile",
  RESET_PASSWORD: "reset-password",
  COURSE_ENROLLED: "course-enrolled",
  ASSESSMENT_STARTED: "assessment-started",
  ASSESSMENT_COMPLETED: "assessment-completed",
  ASSESSMENT_SUBMITTED: "assessment-submitted",
  VIEW_PAGE: "view-page",
  FREE_COURSE_FILTER_APPLIED: "free-course-filter-applied",
  SEARCH_FILTER_APPLIED: "search-filter-applied",
  PROFILE_UPDATED: "profile-updated",
  PAGE_LEFT: "page-left",
  LOCKED_COURSE_ATTEMPT: "locked-course-attempt",
  APP_VISITED: "app-visited",
  APP_LEFT: "app-left",
}